import * as React from "react";

const AISearch = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M9.5 4.5L8.875 3.125L7.5 2.5L8.875 1.875L9.5 0.5L10.125 1.875L11.5 2.5L10.125 3.125L9.5 4.5ZM9.5 11.5L8.875 10.125L7.5 9.5L8.875 8.875L9.5 7.5L10.125 8.875L11.5 9.5L10.125 10.125L9.5 11.5ZM4.5 10L3.25 7.25L0.5 6L3.25 4.75L4.5 2L5.75 4.75L8.5 6L5.75 7.25L4.5 10ZM4.5 7.575L5 6.5L6.075 6L5 5.5L4.5 4.425L4 5.5L2.925 6L4 6.5L4.5 7.575Z"
      fill="currentColor"
    />
  </svg>
);

export default AISearch;
